<template>
  <div>
    <MainServiceSwitcher :home="true" />
  </div>
</template>
<script>
import MainServiceSwitcher from "./main_service_switcher.vue";
export default {
  components: {
    MainServiceSwitcher,
  },
  data() {
    return {
      news: [],
      loading: false,

      name: "",
      email: "",
      subject: "",
      message: "",
      show_thankyou: false,
      form_loading: false,
    };
  },
  methods: {
    submit_form() {
      this.form_loading = true;
      let fd = new FormData();
      fd.append("name", this.name);
      fd.append("email", this.email);
      fd.append("subject", this.subject);
      fd.append("message", this.message);
      axios
        .post(window.base + "/home/SendEmail", fd)
        .then((response) => {
          this.show_thankyou = true;
          this.form_loading = false;
        })
        .catch(() => {
          this.show_thankyou = true;
          this.form_loading = false;
        });
    },
  },
  mounted() {
    // setTimeout(()=>{
    // 	let btn = document.querySelector('#app');
    // 	btn.addEventListener('mousemove', e => {
    // 	let rect = e.target.getBoundingClientRect();
    // 	let x = e.clientX// - rect.left;
    // 	let y = e.clientY// - rect.top;
    // 	btn.style.setProperty('--x', x + 'px');
    // 	btn.style.setProperty('--y', y + 'px');
    // 	});
    // }, 1000)
    // document.querySelector('body').style.backgroundImage = 'url(/cover2.png)'
    // this.loading = true
    // axios.get(window.base+'/news?lang='+this.$i18n.locale).then(response=>{
    // 	this.news = response.data
    // 	this.loading = false
    // }).catch(error=>{
    // 	this.loading = false
    // 	alert('News loading '+error)
    // })
  },
};
</script>
<style scoped>
.welcome .inner-wrapper {
  z-index: 1 !important;
}
.welcome {
  height: auto !important;
  min-height: 100vh !important;
  padding-top: 15vh !important;
  background-repeat: no-repeat;
  background-size: contain;
}
.welcome .home-background-image {
  height: 100%;
}

.loading-hm {
  /* display: none; */
  background: #fff;
  text-align: center;
  padding: 15px;
}
.loading-hm:before {
  content: "";
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin: 0 10px -6px 0;
  border: 3px solid #18d26e;
  border-top-color: #eee;
  -webkit-animation: animate-loading 1s linear infinite;
  animation: animate-loading 1s linear infinite;
}
@-webkit-keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes animate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
